// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/spend_management/memberships/bank_details/firstparty/v3/get_bank_details.proto

/* oxlint-disable */
import { ApiMembershipBankDetails } from "./bank_details";

/** Request message for GetBankDetails. */
export interface ApiGetBankDetailsRequest {
  /** The ID of the membership (path parameter). */
  readonly id: string;
}

/** Response message for GetBankDetails. */
export interface ApiGetBankDetailsResponse {
  /** The bank details of the membership, if any. */
  readonly membershipBankDetails?: ApiMembershipBankDetails | null | undefined;
}

export const ApiGetBankDetailsRequest: MessageFns<ApiGetBankDetailsRequest> = {
  fromJSON(object: any): ApiGetBankDetailsRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: ApiGetBankDetailsRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    return obj;
  },
};

export const ApiGetBankDetailsResponse: MessageFns<ApiGetBankDetailsResponse> = {
  fromJSON(object: any): ApiGetBankDetailsResponse {
    return {
      membershipBankDetails: isSet(object.membershipBankDetails)
        ? ApiMembershipBankDetails.fromJSON(object.membershipBankDetails)
        : null,
    };
  },

  toJSON(message: ApiGetBankDetailsResponse): unknown {
    const obj: any = {};
    if (message.membershipBankDetails !== undefined && message.membershipBankDetails !== null) {
      obj.membershipBankDetails = ApiMembershipBankDetails.toJSON(message.membershipBankDetails);
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
